import request from '../index'

/**
 * 360ocpc数据上报
 * @param {*} data
 * @returns
 */
export function ocpc360Report(data) {
    return request({
        url: '/common/ocpc360',
        method: 'post',
        data
    })
}
